export default {
      id: "icon-pkw-usage",
      viewBox: "0 0 24 24",
      url: "/" + "sprite.svg#icon-pkw",
      toString: function () {
        return this.url;
      }
    }